import React from 'react';
import { Link } from "react-router-dom";




const GetInvolved = () => {
    const cards = [
        {
            title: "Volunteer with Us",
            description:
                "Join our team of volunteers who are making a direct impact on underserved communities. Your time can change lives!",

            bgColor: "#45E99E",
        },
        {
            title: "Donate",
            description:
                "Your donation helps us continue to connect patients with the care they deserve. Every contribution counts towards improving healthcare access for underserved populations.",
            bgColor: "#F9EFCC",
        },
    ];

    return (
			<section className='bg-[#E4FFF2] '>
				<div className='py-16 max-w-[1440px] w-[90%] mx-auto space-y-10'>
					<div className='text-center'>
						<h2 className='text-4xl lg:text-[64px] font-semibold text-[#1D1D1D] leading-tight'>
							Get Involved
						</h2>
						<p className='lg:text-2xl/8 text-lg/6 text-[#11112d] font-normal mt-4 leading-relaxed'>
							Help Us Make a Difference
						</p>
					</div>
					<div className='flex flex-col lg:flex-row justify-center gap-8'>
						{cards.map((card, index) => (
							<div
								key={index}
								className='space-y-6 xl:max-w-[612px] xl:w-full lg:w-1/2 w-full sm:p-8 p-5 rounded-[30px]'
								style={{ backgroundColor: card.bgColor }}>
								<h3 className='text-3xl lg:text-5xl font-medium mb-4 text-[#025788]'>
									{card.title}
								</h3>
								<p className='lg:text-2xl/8 text-lg/6 font-normal text-[#025788]'>
									{card.description}
								</p>
							</div>
						))}
					</div>
					{/* Buttons Section */}
					<div className='flex sm:flex-row flex-col sm:gap-8 gap-5 w-full items-center justify-center'>
						{/* Link to /donate */}
						<Link
							to='/volunteer'
							className='text-[#0A142F] lg:text-lg/7 bg-[#22E27F] lg:px-[78px] px-[43px] lg:py-5 py-[11px] lg:rounded-[67px] rounded-[37px] font-semibold sm:w-fit w-full text-center'>
							Volunteer
						</Link>
						{/* Link to /volunteer */}
						<Link
							to='/donate'
							className='text-[#0A142F] lg:text-lg/7 lg:px-[78px] px-[43px] lg:py-5 py-[11px] lg:rounded-[67px] rounded-[37px] border-[#0A142F] border font-semibold sm:w-fit w-full text-center'>
							Donate Now
						</Link>
					</div>
				</div>
			</section>
		);
};

export default GetInvolved;

